import { gspx } from '@rsos/gainsight';

export const trackRolePageAccess = (role, pageAccess, irpVersion) => {
  const displayPageAccess = pageAccess.join();

  gspx.trackCustomEvent('Admin', {
    irpVersion,
    name: `Selected/Checked and saved ${displayPageAccess}`,
    Category: 'Admin',
    'Launched date': new Date(),
    Role: role,
  });
};

export const trackAddRole = (role, irpVersion) => {
  gspx.trackCustomEvent('Admin', {
    irpVersion,
    name: `Add a new role ${role}`,
    Category: 'Admin',
    'Launched date': new Date(),
  });
};
